module.exports = __webpack_public_path__ + "static/media/sparkAR.967ae5f6.png";